import React from 'react';
import { FaGithub, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { animateScroll as scroll } from 'react-scroll';

import { FooterContainer, FooterLink, FooterLinkItems, FooterLinkTitle, FooterLinksContainer, FooterLinksWrapper, FooterWrap, FooterLinkA, SocialMedia, SocialMediaWrap, SocialLogo, SocialIcons, SocialIconLink, WebsiteRights } from './FooterElements';

const Footer = () => {

    const toggleHome = () => {
        scroll.scrollToTop();
    }

    return (
        <FooterContainer>
            <FooterWrap>
                <FooterLinksContainer>
                    <FooterLinksWrapper>
                        <FooterLinkItems>
                            <FooterLinkTitle>Know More</FooterLinkTitle>
                            <FooterLink to="/schooling">Schooling</FooterLink>
                            <FooterLink to="/exp">Experience</FooterLink>
                        </FooterLinkItems>
                    </FooterLinksWrapper>
                    <FooterLinksWrapper>
                        <FooterLinkItems>
                            <FooterLinkTitle>Social Media</FooterLinkTitle>
                            <FooterLinkA target="_blank" href="https://www.instagram.com/ish.takkar/" >Istagram</FooterLinkA>
                            <FooterLinkA target="_blank" href="https://twitter.com/ishtakkar21" >Twitter</FooterLinkA>
                            <FooterLinkA target="_blank" href="https://www.linkedin.com/in/ish-takkar-486965192/" >LinkedIn</FooterLinkA>
                            <FooterLinkA target="_blank" href="https://github.com/IshTakkar" >GitHub</FooterLinkA>
                        </FooterLinkItems>
                    </FooterLinksWrapper>
                </FooterLinksContainer>
                <SocialMedia>
                    <SocialMediaWrap>
                        <SocialLogo to="/" onClick={toggleHome}>IshTakkar</SocialLogo>
                        <WebsiteRights>Ish Takkar © {new Date().getFullYear()} All rights reserved.</WebsiteRights>
                        <SocialIcons>
                            <SocialIconLink target="_blank" href="https://www.instagram.com/ish.takkar/"><FaInstagram /></SocialIconLink>
                            <SocialIconLink target="_blank" href="https://twitter.com/ishtakkar21"><FaTwitter /></SocialIconLink>
                            <SocialIconLink target="_blank" href="https://www.linkedin.com/in/ish-takkar-486965192/"><FaLinkedin /></SocialIconLink>
                            <SocialIconLink target="_blank" href="https://github.com/IshTakkar"><FaGithub /></SocialIconLink>
                        </SocialIcons>
                    </SocialMediaWrap>
                </SocialMedia>
            </FooterWrap>
        </FooterContainer>
    );
};

export default Footer;